<template>
    <CModal
            width="720px"
            v-model="visible"
            title="查看详情"
            :okLoading="saveLoading"
            @on-ok="save"
            @on-cancel="onCancel">
        <!-- <div slot="footer"></div> -->
        
            <!--顶部查询条件-->
            <div class="form-area">
      <Form style="width: 900px" ref="form" :model="model" :label-width="110" label-position="left"
            inline>
        <FormItem :class="{'model-hidden': true}" label="文本框">
                        <Input :readonly="edit" v-model="model.id"  type="text"></Input>
                    </FormItem>
                          <FormItem  label="姓名">
                              <Input :readonly="edit" v-model="model.name" style="width:320px" type="text"></Input>
                          </FormItem><br>
                          <FormItem  label="手机号">
                              <Input :readonly="edit" v-model="model.phone" style="width:320px" type="text"></Input>
                          </FormItem><br>
                          <FormItem  label="反馈内容">
                              <Input :readonly="edit" v-model="model.content" style="width:320px" type="text"></Input>
                          </FormItem><br>
                          <FormItem label="解决时间">
                              <DatePicker  v-model="model.solveTime" style="width: 320px" type="date" format="yyyy-MM-dd"
                                          clearable></DatePicker><br>
                          </FormItem>
      </Form>
    </div>
            <!-- <Table style="max-height: 300px;overflow: auto" border :columns="modalColumns"
                   :data="modalTableData" :loading="loading"></Table> -->
    </CModal>
</template>
<script>
    import CModal from '@/components/cModel'

    export default {
        components: {CModal},
        // props: ['userid'],
        data () {
            return {
                saveLoading:false,
                edit:false,
                loading: false,
                visible: false,
                dialogVisible: false,
                model: {
                    solveTime:"",
                    status:1,
                },
                
                modalTableData: [],
                baseInfo: {},
                
            }
        },
        watch: {
            userid (val) {
                if (val) {
                    this.init(val)
                }
            }
        },
        mounted () {

        },
        methods: {

            onCancel () {
                this.model = {}
                // this.picList = []
                this.visible = false
            },
            //保存
    save() {
    //   this.$refs['form'].validate((valid) => {
    //     if (!valid) {
    //       return
    //     }
        if (this.model.id) {
          this.update()
        } else {
          this.create()
        }
    //   })
    },

//    create () {
//                 let _this = this
//                 _this.saveLoading = true
//                 _this.$util.http
//                         .post('/api/serviceAdmin/insert', this.model, {
//                             headers: {
//                                 'Content-Type': 'application/json'
//                             }
//                         })
//                         .then(function (response) {
//                             _this.$Notice.success({
//                                 title: '保存成功!'
//                             })
//                             _this.onCancel()
//                             _this.$parent.listTable()
//                         })
//                         .catch(function (error) {
//                             _this.$Notice.error({
//                                 title: '保存失败!'
//                             })
//                             _this.saveLoading = false
//                             console.log(error)
//                         })
//             },

            update () {
                let _this = this
                _this.saveLoading = true
                _this.$util.http
                        .post('/api/tqtFeedbacks', this.model)
                        .then(function (response) {
                            _this.$Notice.success({
                                title: '更新成功!'
                            })
                            _this.onCancel()
                            _this.$parent.listTable()
                        }).finally(()=>{
                            _this.saveLoading = false
                        })
            },
            

           
        }
    }
</script>
<style scoped>
    .title {
        display: flex;
        border-bottom: none;
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        padding-left: 6px;
    }

    .p {
        width: 33%;
        text-align: center;
    }
    .model-hidden {
        display: none;
    }
</style>
